/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM, SYSTEM_COLOR } from "@adapptio/lib-components";
import { Button, IButtonProps } from "./Button/Button";

export enum ICON_BUTTON_SIZE {
	XSMALL = "xsmall",
	MEDIUM = "medium"
}

export interface IIconButtonProps extends IButtonProps {
	color?: SYSTEM_COLOR;
	size?: ICON_BUTTON_SIZE;
}

export const IconButton: React.FC<IIconButtonProps> = ({ className, size, color, ...props }) => {
	const baseClass = BEM(`edt-icon-button-${size}`, null, {
		style: color
	});

	if (className) {
		baseClass.add(className);
	}

	return <Button baseClass={baseClass} hideMenuArrow {...props} />;
};

IconButton.defaultProps = {
	size: ICON_BUTTON_SIZE.MEDIUM
};
